<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
      <div class="grid" *ngIf="carInformacionInicial">
        <div class="col-12 md:col-12 lg:col-12 text-center">
          <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
          <span>{{'LBL_CONSULTANDO' | translate }}</span>
        </div>
      </div>
      <div *ngIf="!carInformacionInicial">
        <div class="grid">
          <div class="col-12 md:col-12">
                <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fRegionalDistritos" name="fRegionalDistritos">
                  <div class="grid form-group">
                    <div class="col-12 md:col-6 lg:col-6">
                      <div class="div-form">
                        <label>* {{ 'EXCEPCIONESGMF.LBL_DESTINOS' | translate }}</label>
                        <p-dropdown disableTab  id="idDestino" name="nomIdRegional" [options]="listaDestinosProducto"
                                    placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                     formControlName="idDestino"
                        ></p-dropdown>
                        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idDestino.invalid">
                          {{ 'EXCEPCIONESGMF.LBL_DESTINOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 md:col-6 lg:col-6 pt-5">
                      <div class="div-form">
                        <div *ngIf="!guardando">
                          <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                                  type="submit" [disabled]="guardando"
                                  pButton></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
          </div>
          <div class="col-12 md:col-12 lg:col-12">
            <p-table [columns]="columnas" [loading]="carTabla" #dt
                     [value]="excepcionesGMFDestino" selectionMode="single" dataKey="idAgrupacion"
                     [paginator]="true" [rows]="10"  paginatorPosition="bottom">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr [pSelectableRow]="row">
                  <td>{{row.destino}}</td>
                  <td class="text-center">
                    <div class="btn-group" role="group">
                      <button type="button" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                             (click)="eliminar( row )" title="{{'BTN_ELIMINAR' | translate}}"
                              pButton ></button>

                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length">
                    {{ 'MSG_NOHAYREGISTROS' | translate}}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div class="col-12 md:col-12">
            <div class="grid form-footer-buttons">
              <div class="form-group col-12">
                <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                        pButton (click)="regresar( false )"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
